import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
	expanded: {
		backgroundColor: theme.colors.orange,
	},
}));

export default useStyles;
